import styled from 'styled-components';
import { lightGrey2Color, lightGrey1Color } from 'js/config/style';

export default styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-template-areas:
    'buyer    price    buttons'
    'location shipping buttons';
  grid-column-gap: 1rem;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: ${lightGrey1Color};

    i {
      color: ${lightGrey2Color.darken()};
    }
  }
  &:active {
    background: ${lightGrey1Color.darken(0.25)};
  }

  && + && {
    border-top: 1px solid ${lightGrey2Color};
  }
`;
